import React from "react";
import {observer} from "mobx-react";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {IArenaViewModel} from "../../services/arenas/models/arenas/arena-view-model.interface";
import {SwiperWindowComponent} from "../orbit-swiper/swiper-window.component";
import {IntersectionSpyComponent} from "../../basic-components/intersection-spy/intersection-spy.component";

const INITIAL_BATCH_SIZE = 0;
interface ArenaGamesListsComponentProps {
    arenaName: string;
}

interface ArenaGamesListsComponentState {
    swiperWindowsCount: number;
}

@observer
export class ArenaGamesListsComponent extends OrbitComponentWithState<ArenaGamesListsComponentProps, ArenaGamesListsComponentState> {

    constructor(props: ArenaGamesListsComponentProps) {
        super(props);

        this.state = {
            swiperWindowsCount: INITIAL_BATCH_SIZE
        };
    }

    private _intersectionSpy: HTMLElement = null;

    private get _arena(): IArenaViewModel {
        return this.services.arenas.getArena(this.props.arenaName);
    }


    componentDidMount() {
        super.componentDidMount();
        //we need this reaction in order for the list to rerender upon login/logout
        this.reaction(() => this.services.user.isAuthorized,
            () => {
                this.setState({
                    swiperWindowsCount: INITIAL_BATCH_SIZE
                });
            });
    }

    private _loadNextBatch(): void {
        const nextBatch = this._arena.getNextBatchSize(this.state.swiperWindowsCount);
        if(nextBatch === 0) {
            return;
        }

        this.setState({
            swiperWindowsCount: this.state.swiperWindowsCount + nextBatch
        }, () => {
            this._ensureIntersectionSpyIsOutsideOfViewPort();
        });
    }

    private _timeoutRef: any = null;
    private _ensureIntersectionSpyIsOutsideOfViewPort() {
        if(this._timeoutRef) {
            clearInterval(this._timeoutRef);
        }

        this._timeoutRef = setTimeout(() => {
            if(this._intersectionSpy) {
                if (this._intersectionSpy.getBoundingClientRect().top < this.services.mainScreen.mainScreenElement.getBoundingClientRect().bottom) {
                    this._loadNextBatch();
                }
            }
        }, 250);
    }

    private _onIntersect = () => {
        this._loadNextBatch();
    }

    private _onCaptureIntersectionSpyRef = (element: HTMLElement) => {
        this._intersectionSpy = element;
    }

    private _onFailedToCreateIntersectionSpy = () => {
        // if it fails to create the IntersectionObserver we give up on lazy loading and render all lists
        this.setState({
            swiperWindowsCount: this._arena.listsCount
        });
    }

    get _windowsRange(): number[] {
        return Array.from({length: this.state.swiperWindowsCount}, (x, i) => i + 1);
    }

    render() {
        const range = this._windowsRange;
        this._ensureIntersectionSpyIsOutsideOfViewPort();
        return (
            <React.Fragment key={`${this.props.arenaName}_LISTS`}>
                {range.map(listWindowPosition => (<SwiperWindowComponent key={listWindowPosition}
                                                                                      windowPosition={listWindowPosition}
                                                                                      arena={this._arena}/>))}

                <IntersectionSpyComponent onIntersect={this._onIntersect}
                                          onCaptureIntersectionSpyRef={this._onCaptureIntersectionSpyRef}
                                          onFailedToCreateIntersectionSpy={this._onFailedToCreateIntersectionSpy}
                                          cyClass={'cy-intersection-observer-target'}/>
            </React.Fragment>
        );
    }
}